import React from 'react';

import { OpenapiProxyStaffGetParticipantResponse200Type } from 'src/api_openapi/generated/openapi_proxy_staff_get_participant';
import { observable, makeAutoObservable } from 'mobx';
import { MobxMap } from 'src_common/common/mobx-utils/MobxMap';
import { ParticipantsInputOutrightsState } from './ParticipantsInputOutrights.state';
import { ParticipantsInputTwoParticipantsState } from './ParticipantsInputTwoParticipantsState';
import { ParticipantsType } from 'src/AppState/sdk/staff';

const createMap = (): MobxMap<[string, string], OpenapiProxyStaffGetParticipantResponse200Type> => {
    return new MobxMap(async ([sport, searchQueryIn]: [string, string]) => {
        if (sport.trim() === '') {
            return [];
        }

        const searchQuery = searchQueryIn.trim();

        if (searchQuery.length === 1 || searchQuery.length === 2) {
            return [];
        }

        if (searchQuery === '') {
            return await $appState.sdkStaff.getParticipants({
                requestBody: {
                    sport: sport,
                },
            });
        }

        const key = searchQuery.trim().search(' ') !== -1 ? 'name' : 'ngram';
        const requestBody = {
            sport,
            [key]: searchQuery,
        };

        return await $appState.sdkStaff.getParticipants({ requestBody });
    });
};

export interface RoleObjectType {
    role?: string;
    participant?: string;
    name?: string;
}

export class ParticipantsInputGroupState {
    @observable public searchQuery: string = '';

    public readonly outrights: ParticipantsInputOutrightsState;
    public readonly twoParticipants: ParticipantsInputTwoParticipantsState;

    @observable mode: 'choose' | 'add' = 'choose';
    @observable newParticipantName: string = '';

    @observable.ref public participantsResource: MobxMap<[string, string], ParticipantsType>;

    constructor() {
        this.outrights = new ParticipantsInputOutrightsState();
        this.twoParticipants = new ParticipantsInputTwoParticipantsState();

        this.participantsResource = createMap();
        makeAutoObservable(this);
    }

    public onSearch(value: string): string {
        this.searchQuery = value;
        return value;
    }

    public openModal = (): void => {
        this.mode = 'add';
    };

    public closeModal = (): void => {
        this.mode = 'choose';
        this.newParticipantName = '';
    };

    public changeNewParticipantName = (e: React.ChangeEvent<HTMLInputElement>): void => {
        this.newParticipantName = e.target.value;
    };

    public createParticipant = async (sportId: string): Promise<void> => {
        console.info('createParticipant');

        await $appState.sdkStaff.createParticipant({
            requestBody: {
                name: this.newParticipantName,
                sport: sportId,
                isCreation: true,
            },
        });

        this.participantsResource = createMap();
    };
}
